import React, { useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu, } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Chips } from "primereact/chips";
import { MultiSelect } from "primereact/multiselect";
import { Editor } from "primereact/editor";
import { Sidebar } from "primereact/sidebar";
import { Link, useLocation } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import Select from 'react-select';
import { TreeSelect } from "primereact/treeselect";
import { Tooltip } from 'primereact/tooltip';
import { InputTextarea } from "primereact/inputtextarea";
import { createContact, getCompanies, getLookupsByName } from "../../helpers/backend-helper";
import axios from 'axios';
import { getCookie } from '../../helpers/cookie';
import { post } from '../../helpers/api-helper';
import { Toast } from "primereact/toast";

const AddContact = ({company,apiStatus}) => {
    const [visibleRightContacts, setVisibleRightContacts] = useState(false);
  const toast = useRef(null) // Reference for Toast notifications
    const token = getCookie('access_token');
    // Form field state variables
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email1, setEmail1] = useState("");
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState();
    const [phno1, setPhno1] = useState("");
    const [userid1, setUserid1] = useState("");
    const [companyField, setCompanyField] = useState(false);
    useEffect(() => {
        setSelectedCompany(company[0]?.id)
        if (company && company.length === 1) {
            setCompanyField(true)
        }
        else {
            setCompanyField(false)
        }
    }
        , [company])
    // Loading state
    const [loading, setLoading] = useState(false);
    const [companiesLoading, setCompaniesLoading] = useState(false);
    const [designationsLoading, setDesignationsLoading] = useState(false);
    const [departmentsLoading, setDepartmentsLoading] = useState(false);
    const [categoriesLoading, setCategoriesLoading] = useState(false);
    const [groupsLoading, setGroupsLoading] = useState(false);
    
    // Companies state
    const [companies, setCompanies] = useState([]);
    
    // Designations state
    const [designations, setDesignations] = useState([]);
    
    // Departments state
    const [departments, setDepartments] = useState([]);
    
    // Categories state
    const [categories, setCategories] = useState([]);
    
    // Groups state
    const [groups, setGroups] = useState([]);

    // Lookup modal state (Add / Edit lookup values)
    const [lookupModalVisible, setLookupModalVisible] = useState(false);
    const [lookupModalContext, setLookupModalContext] = useState(null); // 'designation' | 'department' | 'category' | 'group'
    const [lookupFormValue, setLookupFormValue] = useState('');
    const [editingLookup, setEditingLookup] = useState(false);
    const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null);
    const [lookupDescription, setLookupDescription] = useState('')
    const [selectedEditdrop, setSelectedEditdrop] = useState(null)
    const [selecteddropoptions, setselecteddropoptions] = useState([])

    const lookupAddSentinel = { id: "add", value: "Add New", name: "Add New", label: "Add New", icon: "pi pi-plus" };
    const lookupEditSentinel = { id: "edit", value: "Edit Selected", name: "Edit Selected", label: "Edit Selected", icon: "pi pi-pencil" };

    const lookupItemTemplate = (option) => {
        if (!option) return null;
        return (
            <div className="flex align-items-center gap-2">
                {option.icon && <i className={option.icon} />}
                <span style={option.id === 'add' || option.id === 'edit' ? { fontStyle: 'italic'} : {}}>{option.label || option.name || option.value}</span>
            </div>
        );
    }

    // Private state variables
    const [privateDrop, setPrivateDrop] = useState(false)
    const [PrivetDropdown, setPrivetDropdown] = useState([])
    const [PrivetDropdownValues, setPrivetDropdownValues] = useState(null)

    const [selectedCategory1, setSelectedCategory1] = useState(null);

    const [selectedGroup1, setSelectedGroup1] = useState(null);

    const [selectedDepartment, setSelectedDepartment] = useState(null);

    const [selectedPerson, setSelectedPerson] = useState(null);

    // Keep track of last selected ids so edit sentinel can work like example
    const [lastSelectedDesignationId, setLastSelectedDesignationId] = useState(null);
    const [lastSelectedDepartmentId, setLastSelectedDepartmentId] = useState(null);
    const [lastSelectedCategoryId, setLastSelectedCategoryId] = useState(null);
    const [lastSelectedGroupId, setLastSelectedGroupId] = useState(null);

    // const personOptions = [
    //     { name: 'Salmanuddin Syed', role: 'Operation Head', code: 'OH', id: 1 },
    //     { name: 'Girish Bodepu', role: 'Manager', code: 'MGR', id: 2 },
    //     { name: 'Suresh Reddy', role: 'Team Lead', code: 'TL', id: 3 },
    //     { name: 'Ravi Kumar', role: 'Team Lead', code: 'TL', id: 4 },
    //     { name: 'Neha Patel', role: 'Team Lead', code: 'TL', id: 5 }
    // ];
    const [personOptions, setPersonOptions] = useState([]);
    console.log(personOptions, 'personOptions');
    
 const getallactivecontacts = async () => {

    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/contacts/?is_archived=false`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.results;
        const options = results.map((category) => ({
          name: category.first_name + ' ' + category.last_name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          code: category.id,
          role: category.email
        }));
        setPersonOptions(options);
      }
    } catch (error) {

    }
  };
    useEffect(() => {
        getallactivecontacts();
    }, []);
    const [address, setAddress] = useState("")
    const [selectedState, setSelectedState] = useState("")
    const [selectedCity, setSelectedCity] = useState("")
    const [selectedCountry, setSelectedCountry] = useState("")
    const [selectedLabel, setSelectedLabel] = useState(null)
    const [postalCode, setPostalCode] = useState("")
    const [street1, setStreet1] = useState("")
    const [street2, setStreet2] = useState("")
    const updateAddress = () => {
        // setAddress(`${street1}  ${street2} ${postalCode}`.trim());
    }
 const getPrivateOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data) {
                let results = response.data.data;
                console.log(results, 'results');
                const options = results.map((category) => ({
                    name: category.name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    code: category.id,
                    email: category.email,
                }));
                setPrivetDropdownValues(options);
            }
        } catch (error) {
            // Fallback in case of error
            console.error('Error fetching private users:', error);
        }
    };
    useEffect(() => {
        getPrivateOptions();
    }, []);
    // Fetch companies from database
    const fetchCompanies = async () => {
        try {
            setCompaniesLoading(true);
            console.log('Fetching companies from database...');
            
            const response = await getCompanies();
            console.log('Companies API response:', response);
            console.log('Response type:', typeof response);
            console.log('Is response an array?', Array.isArray(response));
            
            // Handle different response structures
            let companiesArray = [];
            
            if (Array.isArray(response)) {
                companiesArray = response;
            } else if (response && response.data && Array.isArray(response.data)) {
                companiesArray = response.data;
            } else if (response && response.results && Array.isArray(response.results)) {
                companiesArray = response.results;
            } else {
                console.log('Unexpected response format:', response);
                setCompanies([]);
                return;
            }
            
            if (companiesArray.length > 0) {
                const companiesData = companiesArray.map(company => ({
                    name: company.name || company.company_name,
                    code: company.id,
                    id: company.id
                }));
                console.log('Transformed companies data:', companiesData);
                setCompanies(companiesData);
            } 
        } catch (error) {
            console.error('Error fetching companies:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            setCompanies([]);
        } finally {
            setCompaniesLoading(false);
        }
    };

    // Fetch designations from database
    const fetchDesignations = async () => {
        try {
            setDesignationsLoading(true);
            console.log('Fetching designations from database...');
            
            const response = await getLookupsByName('contact_designation');
            console.log('Designations API response:', response);
            
            // Handle the specific nested response structure
            let designationsArray = [];
            
            if (response && response.results && response.results.results && Array.isArray(response.results.results)) {
                // Handle nested results structure: response.results.results
                designationsArray = response.results.results;
            } else if (response && response.results && Array.isArray(response.results)) {
                // Handle simple results structure: response.results
                designationsArray = response.results;
            } else if (Array.isArray(response)) {
                // Handle direct array response
                designationsArray = response;
            } else if (response && response.data && Array.isArray(response.data)) {
                // Handle data structure: response.data
                designationsArray = response.data;
            } else {
                console.log('Unexpected designation response format:', response);
                setDesignations([]);
                return;
            }
            
            console.log('Designations array found:', designationsArray);
            
            if (designationsArray.length > 0) {
                const designationsData = designationsArray.map(designation => ({
                    value: designation.value || designation.name,
                    code: designation.id,
                    id: designation.id
                }));
                console.log('Transformed designations data:', designationsData);
                setDesignations(designationsData);
            } else {
                console.log('No designations found in database');
                setDesignations([]);
            }
        } catch (error) {
            console.error('Error fetching designations:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            setDesignations([]);
        } finally {
            setDesignationsLoading(false);
        }
    };

    // Fetch departments from database
    const fetchDepartments = async () => {
        try {
            setDepartmentsLoading(true);
            console.log('Fetching departments from database...');
            
            const response = await getLookupsByName('contact_department');
            console.log('Departments API response:', response);
            
            // Handle the specific nested response structure
            let departmentsArray = [];
            
            if (response && response.results && response.results.results && Array.isArray(response.results.results)) {
                // Handle nested results structure: response.results.results
                departmentsArray = response.results.results;
            } else if (response && response.results && Array.isArray(response.results)) {
                // Handle simple results structure: response.results
                departmentsArray = response.results;
            } else if (Array.isArray(response)) {
                // Handle direct array response
                departmentsArray = response;
            } else if (response && response.data && Array.isArray(response.data)) {
                // Handle data structure: response.data
                departmentsArray = response.data;
            } else {
                console.log('Unexpected department response format:', response);
                setDepartments([]);
                return;
            }
            
            console.log('Departments array found:', departmentsArray);
            
            if (departmentsArray.length > 0) {
                const departmentsData = departmentsArray.map(department => ({
                    name: department.value || department.name,
                    code: department.id,
                    id: department.id
                }));
                console.log('Transformed departments data:', departmentsData);
                setDepartments(departmentsData);
            } else {
                console.log('No departments found in database');
                setDepartments([]);
            }
        } catch (error) {
            console.error('Error fetching departments:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            setDepartments([]);
        } finally {
            setDepartmentsLoading(false);
        }
    };

    // Fetch categories from database
    const fetchCategories = async () => {
        try {
            setCategoriesLoading(true);
            console.log('Fetching categories from database...');
            
            const response = await getLookupsByName('company_categories');
            console.log('Categories API response:', response);
            
            // Handle the specific nested response structure
            let categoriesArray = [];
            
            if (response && response.results && response.results.results && Array.isArray(response.results.results)) {
                // Handle nested results structure: response.results.results
                categoriesArray = response.results.results;
            } else if (response && response.results && Array.isArray(response.results)) {
                // Handle simple results structure: response.results
                categoriesArray = response.results;
            } else if (Array.isArray(response)) {
                // Handle direct array response
                categoriesArray = response;
            } else if (response && response.data && Array.isArray(response.data)) {
                // Handle data structure: response.data
                categoriesArray = response.data;
            } else {
                console.log('Unexpected categories response format:', response);
                setCategories([]);
                return;
            }
            
            console.log('Categories array found:', categoriesArray);
            
            if (categoriesArray.length > 0) {
                const categoriesData = categoriesArray.map(category => ({
                    label: category.value || category.name,
                    value: category.value || category.name,
                    code: category.id,
                    id: category.id
                }));
                console.log('Transformed categories data:', categoriesData);
                setCategories(categoriesData);
            } else {
                console.log('No categories found in database');
                setCategories([]);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            setCategories([]);
        } finally {
            setCategoriesLoading(false);
        }
    };

    // Fetch groups from database
    const fetchGroups = async () => {
        try {
            setGroupsLoading(true);
            console.log('Fetching groups from database...');
            
            const response = await getLookupsByName('company_group');
            console.log('Groups API response:', response);
            
            // Handle the specific nested response structure
            let groupsArray = [];
            
            if (response && response.results && response.results.results && Array.isArray(response.results.results)) {
                // Handle nested results structure: response.results.results - this is NOT the case based on your API response
                groupsArray = response.results.results;
            } else if (response && response.results && Array.isArray(response.results)) {
                // Handle simple results structure: response.results - this is the correct structure based on your API response
                groupsArray = response.results;
            } else if (Array.isArray(response)) {
                // Handle direct array response
                groupsArray = response;
            } else if (response && response.data && Array.isArray(response.data)) {
                // Handle data structure: response.data
                groupsArray = response.data;
            } else {
                console.log('Unexpected groups response format:', response);
                setGroups([]);
                return;
            }
            
            console.log('Groups array found:', groupsArray);
            
            if (groupsArray.length > 0) {
                const groupsData = groupsArray.map(group => ({
                    label: group.value || group.name,
                    value: group.value || group.name,
                    code: group.id,
                    id: group.id
                }));
                console.log('Transformed groups data:', groupsData);
                setGroups(groupsData);
            } else {
                console.log('No groups found in database');
                setGroups([]);
            }
        } catch (error) {
            console.error('Error fetching groups:', error);
            console.error('Error response:', error.response?.data);
            console.error('Error status:', error.response?.status);
            setGroups([]);
        } finally {
            setGroupsLoading(false);
        }
    };

    // Fetch companies, designations, departments, categories, and groups on component mount
    useEffect(() => {
        fetchCompanies();
        fetchDesignations();
        fetchDepartments();
        fetchCategories();
        fetchGroups();
    }, []);
    useEffect(()=>
      {
        if (apiStatus === true) {
          fetchCompanies([]);
        }
      },[apiStatus])
useEffect(() => {
    // If a real designation id is chosen, store it
    if (selectedDesignation && selectedDesignation !== 'add' && selectedDesignation !== 'edit') {
        setLastSelectedDesignationId(selectedDesignation);
    }

    // Add flow: open blank modal
    if (selectedDesignation === 'add') {
        setLookupModalVisible(true);
        setLookupFormValue('');
        setLookupDescription('')
        setEditingLookup(false);
        setLookupModalContext('designation');
        setSelectedDesignation(null);
        return;
    }

    // Edit flow: prefill with last selected id
    if (selectedDesignation === 'edit') {
        if (lastSelectedDesignationId) {
            setEditingLookup(true);
            const current = designations?.find(opt => String(opt.id) === String(lastSelectedDesignationId));
            setLookupFormValue(current?.value || current?.name || current?.label || current?.value || '');
            setLookupDescription((current && (current.description || current.desc)) || '')
            setLookupModalVisible(true);
            setLookupModalContext('designation');
            setLastSelectedLookupId(lastSelectedDesignationId);
            setSelectedDesignation(null);
            setSelectedEditdrop(lastSelectedDesignationId)
        } else {
            console.warn('No designation selected to edit!');
        }
    }
}, [selectedDesignation, lastSelectedDesignationId, designations]);

// Department add/edit
useEffect(() => {
    if (selectedDepartment && selectedDepartment !== 'add' && selectedDepartment !== 'edit') {
        setLastSelectedDepartmentId(selectedDepartment);
    }

    if (selectedDepartment === 'add') {
        setLookupModalVisible(true);
        setLookupFormValue('');
        setLookupDescription('')
        setEditingLookup(false);
        setLookupModalContext('department');
        setSelectedDepartment(null);
        return;
    }

    if (selectedDepartment === 'edit') {
        if (lastSelectedDepartmentId) {
            setEditingLookup(true);
            const current = departments?.find(opt => String(opt.id) === String(lastSelectedDepartmentId));
            setLookupFormValue(current?.name || current?.label || current?.value || '');
            setLookupDescription((current && (current.description || current.desc)) || '')
            setLookupModalVisible(true);
            setLookupModalContext('department');
            setLastSelectedLookupId(lastSelectedDepartmentId);
            setSelectedDepartment(null);
            setSelectedEditdrop(lastSelectedDepartmentId)
        } else {
            console.warn('No department selected to edit!');
        }
    }
}, [selectedDepartment, lastSelectedDepartmentId, departments]);

// Category add/edit
useEffect(() => {
    if (selectedCategory1 && selectedCategory1 !== 'add' && selectedCategory1 !== 'edit') {
        setLastSelectedCategoryId(selectedCategory1);
    }

    if (selectedCategory1 === 'add') {
        setLookupModalVisible(true);
        setLookupFormValue('');
        setLookupDescription('')
        setEditingLookup(false);
        setLookupModalContext('category');
        setSelectedCategory1(null);
        return;
    }

    if (selectedCategory1 === 'edit') {
        if (lastSelectedCategoryId) {
            setEditingLookup(true);
            const current = categories?.find(opt => String(opt.id) === String(lastSelectedCategoryId));
            setLookupFormValue(current?.label || current?.value || current?.name || '');
            setLookupDescription((current && (current.description || current.desc)) || '')
            setLookupModalVisible(true);
            setLookupModalContext('category');
            setLastSelectedLookupId(lastSelectedCategoryId);
            setSelectedCategory1(null);
            setSelectedEditdrop(lastSelectedCategoryId)
        } else {
            console.warn('No category selected to edit!');
        }
    }
}, [selectedCategory1, lastSelectedCategoryId, categories]);

// Group add/edit
useEffect(() => {
    if (selectedGroup1 && selectedGroup1 !== 'add' && selectedGroup1 !== 'edit') {
        setLastSelectedGroupId(selectedGroup1);
    }

    if (selectedGroup1 === 'add') {
        setLookupModalVisible(true);
        setLookupFormValue('');
        setLookupDescription('')
        setEditingLookup(false);
        setLookupModalContext('group');
        setSelectedGroup1(null);
        return;
    }

    if (selectedGroup1 === 'edit') {
        if (lastSelectedGroupId) {
            setEditingLookup(true);
            const current = groups?.find(opt => String(opt.id) === String(lastSelectedGroupId));
            setLookupFormValue(current?.label || current?.value || current?.name || '');
            setLookupDescription((current && (current.description || current.desc)) || '')
            setLookupModalVisible(true);
            setLookupModalContext('group');
            setLastSelectedLookupId(lastSelectedGroupId);
            setSelectedGroup1(null);
            setSelectedEditdrop(lastSelectedGroupId)
        } else {
            console.warn('No group selected to edit!');
        }
    }
}, [selectedGroup1, lastSelectedGroupId, groups]);

// Map modal context to edit-dropdown options so the edit-only Dropdown can prefill
useEffect(() => {
    if (lookupModalContext === 'designation') {
        setselecteddropoptions((designations || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
    } else if (lookupModalContext === 'department') {
        setselecteddropoptions((departments || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.name || d.value || d.label || String(d.id), code: d.code, raw: d })));
    } else if (lookupModalContext === 'category') {
        setselecteddropoptions((categories || []).map(c => ({ id: c.id ?? c.code ?? c.value, name: c.label || c.value || c.name || String(c.id), code: c.code, raw: c })));
    } else if (lookupModalContext === 'group') {
        setselecteddropoptions((groups || []).map(g => ({ id: g.id ?? g.code ?? g.value, name: g.label || g.value || g.name || String(g.id), code: g.code, raw: g })));
    } else {
        setselecteddropoptions([])
    }
}, [lookupModalContext, designations, departments, categories, groups])


    useEffect(() => {
        const updatedAddress = [
            street1,
            street2,
            selectedCity,
            selectedState,
            selectedCountry,
            postalCode,
            selectedLabel?.name,
        ].filter(Boolean)
        setAddress(updatedAddress.join('\n'))
    }, [
        street1,
        street2,
        postalCode,
        selectedState,
        selectedCity,
        selectedCountry,
        selectedLabel,
    ])

    const [visible, setVisible] = useState(false)


    // Map context to lookup name used by backend
    const lookupContextToName = (context) => {
        switch (context) {
            case 'designation':
                return 'contact_designation';
            case 'department':
                return 'contact_department';
            case 'category':
                return 'company_categories';
            case 'group':
                return 'company_group';
            default:
                return null;
        }
    }

    // Save or update a lookup value (POST / PATCH)
    const handleLookupSave = async () => {
        const context = lookupModalContext;
        const name = lookupContextToName(context);
        if (!name) return;
        try {
            if (lookupFormValue.trim() === '') {
               toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty' })
                return;
            }
            const token = getCookie('access_token');
            const payload = { value: lookupFormValue, name, description: lookupDescription || lookupFormValue };

            if (editingLookup && lastSelectedLookupId) {
                // PATCH
                await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } else {
                // POST
                await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }

            // Refresh the relevant list
            if (context === 'designation') fetchDesignations();
            if (context === 'department') fetchDepartments();
            if (context === 'category') fetchCategories();
            if (context === 'group') fetchGroups();

            setLookupModalVisible(false);
            setLookupFormValue('');
            setEditingLookup(false);
            setLastSelectedLookupId(null);
            setLookupDescription('')
        } catch (err) {
            console.error('Lookup save failed', err);
        }
    }

    const addCities = [
        { name: 'Hyderabad', code: 'HYD' },
        { name: 'Chennai', code: 'CHN' },
        { name: 'Mumbai', code: 'MUM' },
        { name: 'Bangalore', code: 'BLR' },
        { name: 'Delhi', code: 'DEL' },
    ]

    const addStates = [
        { name: 'Andhra Pradesh', code: 'AP' },
        { name: 'Telangana', code: 'TG' },
        { name: 'Tamil Nadu', code: 'TN' },
        { name: 'Karnataka', code: 'KA' },
        { name: 'Kerala', code: 'KL' },
    ]

    const addCountries = [
        { name: "India", code: "IN" },
        { name: "United States", code: "US" },
        { name: "Canada", code: "CA" },
        { name: "Germany", code: "DE" },
        { name: "Australia", code: "AU" },
    ]

    const labels = [
        { name: "Work from Office (WFO)", code: "WORK" },
        { name: "Work from Home (WFH)", code: "HOME" },
        { name: "Work from Remote (WFR)", code: "REMOTE" }
    ]

    // Function to handle contact creation
    const handleCreateContact = async () => {
        // Basic validation
        if (!firstName.trim() || !lastName.trim() || !email1.trim()) {
            alert("Please fill in all required fields (First Name, Last Name, Email)");
            return;
        }

        setLoading(true);
        try {
            console.log("Creating contact...");

            // Prepare contact data
            const contactData = {
                first_name: firstName.trim(),
                last_name: lastName.trim(),
                email: email1.trim(), // Backend expects 'email' field
                phone: phno1.trim(), // Backend expects 'phone' field
                company: selectedCompany,
                designation: selectedDesignation, // Send ID instead of name
                department: selectedDepartment , // Send ID instead of name
                reporting_person: selectedPerson?.code , // Send ID instead of name
                // Address information
                street_address_1: street1.trim(),
                street_address_2: street2.trim(),
                city: selectedCity || "Hyderabad",
                state: selectedState || "Telangana", 
                country: selectedCountry || "India",
                postal_code: postalCode.trim(),
                address_label: address,
                // Category and group
                category: selectedCategory1,
                group: selectedGroup1,
                // User assignment
                user_id: userid1.trim(),
                // Privacy settings
                is_private: privateDrop,
                private_users: privateDrop ? PrivetDropdown.map(user => user.code) : [],
            };

            console.log("Contact data to be sent:", contactData);

            // Call the API
            const response = await createContact(contactData);
            console.log("Contact creation response:", response);

            // Show success message
            alert("Contact created successfully!");

            // Reset form
            setFirstName("");
            setLastName("");
            setEmail1("");
            setPhno1("");
            setSelectedDesignation(null);
            setSelectedCompany(null);
            setSelectedDepartment(null);
            setSelectedPerson(null);
            setStreet1("");
            setStreet2("");
            setPostalCode("");
            setSelectedCity("");
            setSelectedState("");
            setSelectedCountry("");
            setSelectedLabel(null);
            setSelectedCategory1(null);
            setSelectedGroup1(null);
            setUserid1("");
            setPrivateDrop(false);
            setPrivetDropdown([]);
            setAddress("");

            // Close sidebar
            setVisibleRightContacts(false);

        } catch (error) {
            console.error("Error creating contact:", error);
            console.error("Error details:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status
            });
            
            // Show error message
            alert("Failed to create contact. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (

        <React.Fragment>
            <button
                type="button"
                className="btn btn-secondary import-res-btn  ms-1  me-1"
                onClick={() => setVisibleRightContacts(true)}
            >
                Add Contact
            </button>
        <Toast ref={toast} />
            <Sidebar visible={visibleRightContacts} position="right" className="sidebar" onHide={() => setVisibleRightContacts(false)}>
                <div className="sidebar-header">

                    <h3>Create a Contact</h3>
                    <div className="d-flex align-items-center">
                        {/* <Link to="/candidate-editform">
                                          <p className="mb-0 text-white"> <i class="fa-regular fa-pen-to-square me-3"></i> </p>
                                        </Link> */}
                        <Tooltip target=".closeside" content="Close" position="bottom" style={{ marginBottom: "5px" }} />

                        <Button
                            icon="pi pi-times"
                            className="p-button-text close-btn closeside"
                            onClick={() => setVisibleRightContacts(false)}
                        />
                    </div>

                </div>
                <div className="card sidebardetails">
                    <form>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="firstName">First Name</label>
                                    <InputText
                                        id="firstName"
                                        placeholder="Enter First Name"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        disabled={loading}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="lastName">Last Name</label>
                                    <InputText
                                        id="lastName"
                                        placeholder="Enter Last Name"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        disabled={loading}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="email">Email</label>
                                    <InputText
                                        type="email"
                                        placeholder="Enter Email"
                                        value={email1}
                                        onChange={(e) => setEmail1(e.target.value)}
                                        disabled={loading}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="phoneNumber">Phone Number</label>
                                    <InputText
                                        placeholder="Enter Phone Number"
                                        value={phno1}
                                        onChange={(e) => setPhno1(e.target.value)}
                                        disabled={loading}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="jobTitle" className="p-d-block">Designation</label>
                                    {/* <Dropdown
                                        value={selectedDesignation}
                                        onChange={(e) => { setSelectedDesignation(e.value); }}
                                        options={[...designations, lookupAddSentinel]}
                                        optionLabel="name"
                                        placeholder={designationsLoading ? "Loading" : "Select"}
                                        filter
                                        className="w-full bgclr p-d-block"
                                        disabled={loading || designationsLoading}
                                        itemTemplate={lookupItemTemplate}
                                    /> */}
                                    <Dropdown
                                        id="project"
                                        value={selectedDesignation}
                                        onChange={(e) => setSelectedDesignation(e.value)}
                                        options={[
                                            ...designations,
                                            { id: "add", value: "Add New", icon: "pi pi-plus" },
                                            ...(selectedDesignation ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                                        ]}
                                        placeholder="Select Designation"
                                        className="w-full bgclr"
                                        optionLabel="value"
                                        optionValue="id"
                                        filter
                                        // itemTemplate={(option) => (
                                        //     <div className="flex align-items-center gap-2">
                                        //         {option.icon && <i className={option.icon}></i>}
                                        //         <span>{option.value}</span>
                                        //     </div>
                                        // )}
                                         itemTemplate={lookupItemTemplate}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="company">Company</label>
                                    <Dropdown
                                        value={selectedCompany}
                                        onChange={(e) => setSelectedCompany(e.value)}
                                        options={companies}
                                        optionLabel="name"
                                        placeholder={companiesLoading ? "Loading companies..." : "Select Company"}
                                        filter
                                        optionValue="id"
                                        className="w-full bgclr"
                                        disabled={loading || companiesLoading || companyField}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="company">Department</label>
                                    <Dropdown
                                        value={selectedDepartment}
                                        onChange={(e) => { setSelectedDepartment(e.value); }}
                                        options={[...departments, lookupAddSentinel, ...(selectedDepartment ? [lookupEditSentinel] : [])]}
                                        optionLabel="name"
                                        optionValue="id"
                                        placeholder={departmentsLoading ? "Loading" : "Select Department"}
                                        filter
                                        className="w-full bgclr"
                                        disabled={loading || departmentsLoading}
                                        itemTemplate={lookupItemTemplate}
                                    />
                                </div>
                            </Col>

                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="company">Reporting Person</label>
                                    <Dropdown
                                        value={selectedPerson}
                                        options={personOptions}
                                        onChange={(e) => setSelectedPerson(e.value)}
                                        optionLabel={(option) => `${option.name}, ${option.role}`}
                                        placeholder="Select Reporting Person"
                                        className="bgclr"
                                        disabled={loading}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={12}>
                                <div className="p-field companie-add" style={{ position: "relative" }}>
                                    <label htmlFor="address">Address</label>
                                    <InputTextarea
                                        id="address"
                                        value={address}
                                        // onChange={(e) => setAddress(e.target.value)}
                                        readOnly
                                        placeholder="Enter your address"
                                        style={{ paddingRight: "2rem" }} // Optional styling
                                        rows={8} // Specify number of rows
                                        cols={30} // Specify width
                                    />

                                    {/* Edit Icon */}
                                    <i
                                        className="pi pi-pencil"
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "70%",
                                            transform: "translateY(-50%)",
                                            color: "#6c757d",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setVisible(true)}
                                    ></i>
                                    <Dialog header="Edit Address" className="address-popup" visible={visible} onHide={() => {
                                        setVisible(false);
                                        setStreet1('');
                                        setStreet2('');
                                        setSelectedCity(null);
                                        setSelectedState(null);
                                        setSelectedCountry(null);
                                        setPostalCode('');
                                        setSelectedLabel(null);
                                        setAddress('');
                                    }}
                                        style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                                        <div className="card sidebardetails">
                                            <form>

                                                <Row className="mb-3">
                                                    <Col lg={6}>
                                                        <div className="p-field">
                                                            <label htmlFor="street1">Street 1</label>
                                                            <InputText
                                                                id="street1"
                                                                value={street1}
                                                                onChange={(e) => { setStreet1(e.target.value); updateAddress(); }}
                                                                placeholder="Enter Street 1"
                                                                className="w-full activejobdrop"
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label htmlFor="street2">Street 2</label>
                                                        <InputText
                                                            id="street2"
                                                            value={street2}
                                                            onChange={(e) => { setStreet2(e.target.value); updateAddress(); }}
                                                            placeholder="Enter Street 2 (Optional)"
                                                            className="w-full activejobdrop"
                                                        />
                                                    </Col>
                                                </Row>



                                                <Row className="mb-3">


                                                    <Col lg={6}>
                                                        <label htmlFor="city">City</label>
                                                        <Dropdown
                                                            id="city"
                                                            value={selectedCity}
                                                            onChange={(e) => { updateAddress(); setSelectedCity(e.target.value.name) }}
                                                            options={addCities}
                                                            optionLabel="name"
                                                            filter
                                                            filterPlaceholder="Search City"
                                                            className="w-full activejobdrop"
                                                            placeholder="Hyderabad"
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label htmlFor="state">State</label>
                                                        <Dropdown
                                                            id="state"
                                                            value={selectedState}
                                                            onChange={(e) => { updateAddress(); setSelectedState(e.target.value.name) }}
                                                            options={addStates}
                                                            optionLabel="name"
                                                            filter
                                                            filterPlaceholder="Search State"
                                                            className="w-full activejobdrop"
                                                            placeholder="Telangana"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col lg={6}>
                                                        <label htmlFor="country">Country</label>
                                                        <Dropdown
                                                            id="country"
                                                            value={selectedCountry}
                                                            onChange={(e) => { updateAddress(); setSelectedCountry(e.target.value.name)}}
                                                            options={addCountries}
                                                            optionLabel="name"
                                                            filter
                                                            filterPlaceholder="Search Country"
                                                            className="w-full activejobdrop"
                                                            placeholder="India"
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <label htmlFor="postalCode">Zip Code</label>
                                                        <InputText
                                                            id="postalCode"
                                                            value={postalCode}
                                                            onChange={(e) => { updateAddress(); setPostalCode(e.target.value) }}
                                                            placeholder=""
                                                            className="w-full activejobdrop"
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Col lg={12}>
                                                        <label htmlFor="postalCode">Label</label>
                                                        <Dropdown
                                                            value={selectedLabel}
                                                            onChange={(e) => { updateAddress(); setSelectedLabel(e.value) }}
                                                            options={labels}
                                                            optionLabel="name"
                                                            placeholder="Work From Office"
                                                            className="w-full activejobdrop"
                                                        />
                                                    </Col>
                                                </Row>


                                                <Row>
                                                    <Col>
                                                        <Button
                                                            type="button"
                                                            color="primary"
                                                            className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                                                            onClick={() => { setVisible(false); }}
                                                        >
                                                            <i className="pi pi-check me-1"></i> Save
                                                        </Button>

                                                        <Button
                                                            type="button"
                                                            color="primary"
                                                            className="btn btn-primary waves-effect waves-light cancelbtn me-2"
                                                            onClick={() => {
                                                                setVisible(false);
                                                                setStreet1('');
                                                                setStreet2('');
                                                                setSelectedCity(null);
                                                                setSelectedState(null);
                                                                setSelectedCountry(null);
                                                                setPostalCode('');
                                                                setSelectedLabel(null);
                                                                setAddress('');
                                                            }}
                                                        >
                                                            <i className="pi pi-times me-1"></i>
                                                            Cancel
                                                        </Button>
                                                    </Col>
                                                </Row>

                                            </form>
                                        </div>
                                    </Dialog>
                                    
                                </div>
                            </Col>

                        </Row>

                        <Row className="mb-2">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="company">Categories</label>
                                    <Dropdown
                                        id="category"
                                        value={selectedCategory1}
                                        onChange={(e) => { setSelectedCategory1(e.value); }}
                                        options={[...categories, lookupAddSentinel, ...(selectedCategory1 ? [lookupEditSentinel] : [])]}
                                        itemTemplate={lookupItemTemplate}
                                        placeholder={categoriesLoading ? "Loading" : "Select Categories" }
                                        className="w-full bgclr"
                                        disabled={loading || categoriesLoading}
                                        filter
                                        optionLabel="label"
                                        optionValue="id"
                                    />
                                </div>
                            </Col >

                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="company">Groups</label>
                                    <Dropdown
                                        id="group"
                                        value={selectedGroup1}
                                        onChange={(e) => { setSelectedGroup1(e.value); }}
                                        options={[...groups, lookupAddSentinel, ...(selectedGroup1 ? [lookupEditSentinel] : [])]}
                                        placeholder={groupsLoading ? "Loading" : "Select Groups"}
                                        className="w-full bgclr"
                                        disabled={loading || groupsLoading}
                                        filter
                                        optionLabel="label"
                                        optionValue="id"
                                        itemTemplate={lookupItemTemplate}
                                    />
                                </div>
                            </Col>
                        </Row >

                        <Row className="d-flex align-items-end mb-2 mt-2Avuna">
                            <Col lg={6}>
                                <div className="p-field d-flex align-items-center">
                                    <Checkbox
                                        inputId="privateCheckbox"
                                        checked={privateDrop}
                                        onChange={(e) => setPrivateDrop(e.checked)}
                                    />
                                    <label htmlFor="privateCheckbox" className="ms-2">Private</label>
                                </div>
                            </Col>
                            <Col lg={6}>
                                {privateDrop && (
                                    <div className="p-field">
                                        <label htmlFor="userIds">User Id's</label>
                                        <MultiSelect
                                            value={PrivetDropdown}
                                            onChange={(e) => setPrivetDropdown(e.value)}
                                            options={PrivetDropdownValues}
                                            optionLabel={(option) =>` ${option.name} (${option.email})` }
                                            display="comma"
                                            placeholder="Select User Id's"
                                            maxSelectedLabels={3}
                                            className="w-full"
                                        />
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <Button 
                                    type="button" 
                                    className="btn btn-primary waves-effect waves-light me-2 sidebarbtn float-end" 
                                    onClick={handleCreateContact}
                                    disabled={loading}
                                    loading={loading}
                                >
                                    {loading ? "Creating..." : "Create"}
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </div>

                {/* Lookup Add/Edit Dialog */}
                <Dialog header={editingLookup ? `Edit ${lookupModalContext ? lookupModalContext.charAt(0).toUpperCase() + lookupModalContext.slice(1) : 'Value'}`
                    : `Add ${lookupModalContext
                        ? lookupModalContext.charAt(0).toUpperCase() + lookupModalContext.slice(1)
                        : 'Value'
                    }`
                }
                    visible={lookupModalVisible}
                    onHide={() => setLookupModalVisible(false)}
                    style={{ width: '30vw' }}
                    breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                >


                    <div className="p-fluid">
                        {editingLookup && (
                            <>
                                <label className="mb-1">Select item to edit</label>
                                <Dropdown
                                    value={selectedEditdrop}
                                    options={selecteddropoptions}
                                    onChange={(e) => {
                                        const selectedObj = selecteddropoptions.find((opt) => opt.id === e.value || opt.code === e.value)
                                        setLookupFormValue(selectedObj ? (selectedObj.name || selectedObj.value || selectedObj.label) : '')
                                        const resolvedId = selectedObj ? (selectedObj.id ?? selectedObj.code) : null
                                        setSelectedEditdrop(resolvedId)
                                        setLastSelectedLookupId(resolvedId)
                                    }}
                                    placeholder="Select to prefill"
                                    className="w-full bgclr mb-2"
                                    optionLabel="name"
                                    optionValue="id"
                                    filter
                                />
                            </>
                        )}
                        <label htmlFor="lookupValue">{lookupModalContext ? `${lookupModalContext.charAt(0).toUpperCase() + lookupModalContext.slice(1)}` : 'Value'}</label>
                        <InputText id="lookupValue" value={lookupFormValue} onChange={(e) => setLookupFormValue(e.target.value)} placeholder="Enter value" />
                        <div className="p-field mb-3 mt-2">
                            <label htmlFor="lookupDescription">Description</label>
                            <InputTextarea id="lookupDescription" value={lookupDescription} onChange={(e) => setLookupDescription(e.target.value)} rows={3} placeholder="Enter description (optional)" />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                        <Button label={editingLookup ? "Update" : "Save"} onClick={handleLookupSave} className="me-2" />
                        <Button label="Cancel" className="p-button-secondary" onClick={() => { setLookupModalVisible(false); setLookupFormValue(''); setEditingLookup(false); setLastSelectedLookupId(null); setLookupDescription(''); setSelectedEditdrop(null); }} />
                    </div>
                </Dialog>

            </Sidebar>
        </React.Fragment>
    );
}

    
export default AddContact;
